module.exports = __webpack_public_path__ + "img/auracloud.0f6f43ef.png";